import i18n from "i18next";
import { updateAxiosHeaderAcceptLanguage } from "../api/axios";
import { updateAxiosHeaderGprocessAcceptLanguage } from "../features/g-process/component/api/axios";

export const updateI18nLocale = (locale: "en" | "vn"): void => {
  i18n.changeLanguage(locale);
  updateAxiosHeaderAcceptLanguage(locale);
  updateAxiosHeaderGprocessAcceptLanguage(locale);
};
